import '../../sass/pages/_news.scss'

declare var gsap: any;

document.addEventListener('DOMContentLoaded', (event: any) => {
    showFilter()
    getAllPosts()
    filterActivities()
    cleanFiltersBox()
    cancelFilter()
})

const filterActivities = () => {
    let form = document.getElementById('formFilter') as HTMLFormElement
    form?.addEventListener('submit', event => {
        event.preventDefault();
        const formData: any = new FormData(form)
        //const temp = new URLSearchParams(formData)
        const temp = Object.fromEntries(formData)
        getFilterPosts(temp)
    })
}

const getAllPosts = async () => {
    let url = '/get/blogs'
    try {
        let info = {
            orderBy: '',
            causa: '',
        }
        let res = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        })
        const data = await res.json();
        const qtyEl = data.total
        const perPage = data.pagina
        await renderPosts(data.response)
        await renderFeaturedPosts(data.destacada)
        await loadMore(qtyEl, perPage)
        await showNoResultsMessage(data.response)
    } catch (error) {
        console.log(error)
    }
}
const getFilterPosts = async (temp: any) => {
    let url = '/get/blogs'
    try {
        let res = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(temp)
        })
        const data = await res.json();
        const qtyEl = data.total
        const perPage = data.pagina
        await renderPosts(data.response)
        await loadMore(qtyEl, perPage)
        await showNoResultsMessage(data.response)
    } catch (error) {
        console.log(error)
    }
}


const renderPosts = async (data: any) => {
    let _news = await data
     let leftMainContainer = document.querySelector('.mvm__news__news__grid__left') as HTMLElement
     let bottomContainer = document.querySelector('.mvm__news__news__columns') as HTMLElement
     let rightMainContainer = document.querySelector('.mvm__news__news__grid__right') as HTMLElement
     let templateRight = '' as any
     let templateLeft = '' as any
     leftMainContainer.innerHTML = ''
     bottomContainer.innerHTML = ''
     rightMainContainer.innerHTML = ''
     _news.forEach((element: any, index: any) => {
        if(index === 0){
            templateLeft = 
            `
                <article class="news">
                    <a href="${element.url}">
                        <div class="news__thumbnail">
                            <img src="${element.UrlImg_escritorio}" alt="">
                        </div>
                        <div class="news__body">
                            <div class="news__date">
                            <p class="bold_18">${element.date}</p>
                            </div>
                            <div class="news__title">
                            <h3 class="subtitleSmall">${element.title}</h3>
                            </div>
                            <div class="news__description">
                            <p class="medium_18">
                                ${element.resume}
                            </p>
                            </div>
                        </div>
                    </a>
                </article>
            `
            leftMainContainer.insertAdjacentHTML("beforeend",templateLeft)
        }else if(index === 1 || index === 2 || index === 3){
            templateRight = 
            `
                <article class="news news__small">
                    <a href="${element.url}">
                        <div class="news__thumbnail">
                        <img src="${element.UrlImg_escritorio}" alt="">
                        </div>
                        <div class="news__body">
                        <div class="news__date">
                            <p class="bold_18">${element.date}</p>
                        </div>
                        <div class="news__title">
                            <h3 class="subtitleSmall">${element.title}</h3>
                        </div>
                        <div class="news__description">
                            <p class="medium_18">
                                ${element.resume}
                            </p>
                        </div>
                        </div>
                    </a>
                </article>
            `
            rightMainContainer.insertAdjacentHTML("beforeend",templateRight)
        }else{
            const newsArticle = document.createElement('article');
            newsArticle.classList.add('news', 'news__medium');

            const linkElement = document.createElement('a');
            linkElement.href = element.url;
            newsArticle.appendChild(linkElement);

            const thumbnailElement = document.createElement('div');
            thumbnailElement.classList.add('news__thumbnail');

            const imageElement = document.createElement('img');
            imageElement.src = element.UrlImg_escritorio;
            imageElement.alt = '';
            thumbnailElement.appendChild(imageElement);
            linkElement.appendChild(thumbnailElement);

            const bodyElement = document.createElement('div');
            bodyElement.classList.add('news__body');

            const dateElement = document.createElement('div');
            dateElement.classList.add('news__date');

            const dateParagraph = document.createElement('p');
            dateParagraph.classList.add('bold_18');
            dateParagraph.textContent = element.date;
            dateElement.appendChild(dateParagraph);
            bodyElement.appendChild(dateElement);

            const titleElement = document.createElement('div');
            titleElement.classList.add('news__title');

            const titleHeading = document.createElement('h3');
            titleHeading.classList.add('subtitleSmall');
            titleHeading.textContent = element.title;
            titleElement.appendChild(titleHeading);
            bodyElement.appendChild(titleElement);

            const descriptionElement = document.createElement('div');
            descriptionElement.classList.add('news__description');

            const descriptionParagraph = document.createElement('p');
            descriptionParagraph.classList.add('medium_18');
            descriptionParagraph.textContent = element.resume;
            descriptionElement.appendChild(descriptionParagraph);
            bodyElement.appendChild(descriptionElement);

            linkElement.appendChild(bodyElement);

            bottomContainer.appendChild(newsArticle);
        }
     })
}


const renderFeaturedPosts = async ( data: any) => {
    let info = data[0]
    let featuredBn = document.querySelector('.mvm__news__featured')
    let bg = featuredBn?.querySelector('#bgFeatured') as any
    let date = featuredBn?.querySelector('#dateFeatured')
    let title = featuredBn?.querySelector('#titleFeatured')
    let url = featuredBn?.querySelector('#urlFeatured') as any
    if(Object.keys(info).length){
        bg.src = info.UrlImg_escritorio
        url.href = info.url
        if(date != undefined){
            date.textContent = info.date
        }
        if(title != undefined){
            title.textContent = info.title
        }
    }
}

// Function Show Filter

const showFilter = () => {
    let btnFilter = document.querySelector('.mvm__news__titleFilters__filterBtn');
    let filters = document.querySelector('.mvm__filters') as any;
    let container = document.querySelector('.mvm__filters__form') as any
    let heCont = container?.offsetHeight
    btnFilter?.addEventListener('click', e => {
        if (filters != undefined) {
            filters.style.height = `${heCont}px`
            filters?.classList.add('mvm__filters--active')
        }
    })
}



// LoadMore

const loadMore = async (qtyEl: any, perPage: any) => {
    let loadMore = document.getElementById('loadMoreNews')
    let activities = await Array.from(document.querySelectorAll('.news'))
    if (qtyEl > perPage) {
        loadMore?.classList.add('active')
    } else {
        loadMore?.classList.remove('active')
    }
    activities.forEach((box: any, index) => {
        if (index >= perPage) {
            box.style.display = "none";
        }
    })
    loadMore?.addEventListener('click', e => {
        e.preventDefault()
        perPage += 6
        activities.forEach((box: any, index) => {
            if (index >= perPage) {
                box.style.display = "none";
            }
            else {
                box.style.display = "";
            }
        })
        if (perPage > activities.length) {
            loadMore?.classList.remove('active')
        }
    })


}

// Function para mostrar mensaje cuando no hay resultados

const showNoResultsMessage = (qtyEl: any) => {
    let msg = document.getElementById('noResults')
    if (qtyEl.length === 0) {
        msg?.classList.add('active')
    } else {
        msg?.classList.remove('active')
    }
}

// Function Clean Filter Box

const cleanFiltersBox = () => {
    let cleanBtn = document.getElementById('cleanFilters')
    let form = document.getElementById('formFilter') as HTMLFormElement
    cleanBtn?.addEventListener('click', e => {
        form?.reset()
        getAllPosts()
    })
}

// Function Cancel Filters

const cancelFilter = () => {
    let btnClear = document.getElementById('cancelFilters');
    let form = document.getElementById('formFilter') as HTMLFormElement
    let filters = document.querySelector('.mvm__filters') as any
    btnClear?.addEventListener('click', e => {
        e.preventDefault()
        form?.reset()
        if (filters != undefined) {
            filters.style.height = `0px`
            filters?.classList.remove('mvm__filters--active')
        }
        getAllPosts()
    })
}